import {InjectionToken} from '@angular/core';
import {ProviderMap} from './types';

/**
 * A utility function to create a dummy object associated with a type
 */
export function withType<T>(multi?: boolean): T {
  return {multi: multi} as T; // Placeholder; we don't need to use this at runtime
}

/**
 * Helper function to convert upper snake case to camelCase
 *
 * @param tokenName Name of the token
 * @returns
 */
const toCamelCase = (tokenName: string): string => {
  return tokenName.toLowerCase().replace(/_([a-z])/g, (_, letter: string) => letter.toUpperCase());
};

type InjectionTokenMap<T extends ProviderMap> = {
  [K in keyof T]: InjectionToken<T[K]>;
};

/**
 * Generates a map of injection tokens based on the provider map.
 *
 * @param providerMap Map with all available providers
 * @returns Map with InjectionTokens
 */
export const generateTokens = <T extends ProviderMap>(providerMap: T): InjectionTokenMap<T> => {
  const result = {} as InjectionTokenMap<T>;

  (Object.keys(providerMap) as Array<keyof T>).forEach((key) => {
    const camelCaseName = toCamelCase(key as keyof ProviderMap);
    result[key] = new InjectionToken<T[typeof key]>(camelCaseName);
  });

  return result;
};
